import { render, staticRenderFns } from "./EmotionCommentsForm.vue?vue&type=template&id=85f62dec"
import script from "./EmotionCommentsForm.vue?vue&type=script&lang=js"
export * from "./EmotionCommentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85f62dec')) {
      api.createRecord('85f62dec', component.options)
    } else {
      api.reload('85f62dec', component.options)
    }
    module.hot.accept("./EmotionCommentsForm.vue?vue&type=template&id=85f62dec", function () {
      api.rerender('85f62dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/emotionComments/modules/EmotionCommentsForm.vue"
export default component.exports